import { DateTime } from '@ksyos/date-time';
import { Button } from '@ksyos/design-system';
import { useState } from 'react';
import type {
    IServiceConsumer,
    IServiceEmployment,
    IServiceProvider,
    IServiceReaderWithServices,
    IServiceSupervisor,
} from '@frontend/components/interfaces';
import { translateKey } from '../../../../translate';
import { ServiceRightStopModal } from './ServiceRightStopModal';

interface ITurnRightOffLinkProps {
    organizationId: string;
    reloadServiceRights: () => Promise<void>;
    serviceRight:
        | IServiceProvider
        | IServiceConsumer
        | IServiceSupervisor
        | IServiceReaderWithServices
        | IServiceEmployment;
    serviceRightType:
        | 'ServiceConsumer'
        | 'ServiceProvider'
        | 'ServiceReader'
        | 'ServiceSupervisor'
        | 'ServiceEmployment';
}

export function TurnRightOffLink(props: ITurnRightOffLinkProps) {
    const { serviceRightType, serviceRight, reloadServiceRights, organizationId } = props;
    const today = DateTime.now();
    const serviceRightTypeText =
        serviceRightType === 'ServiceEmployment'
            ? ''
            : translateKey(`serviceRightStopModal.serviceRightType.${serviceRightType}`);
    const serviceProviderRights = serviceRightType === 'ServiceProvider' ? [serviceRight as IServiceProvider] : [];
    const serviceConsumerRights = serviceRightType === 'ServiceConsumer' ? [serviceRight as IServiceConsumer] : [];
    const serviceReaderRights =
        serviceRightType === 'ServiceReader' ? [serviceRight as IServiceReaderWithServices] : [];
    const serviceSupervisorRights =
        serviceRightType === 'ServiceSupervisor' ? [serviceRight as IServiceSupervisor] : [];
    const serviceEmploymentRights =
        serviceRightType === 'ServiceEmployment' ? [serviceRight as IServiceEmployment] : [];

    const [showServiceRightStopModal, setShowServiceRightStopModal] = useState(false);

    return (
        <>
            <Button
                onClick={() => setShowServiceRightStopModal(true)}
                variant="link"
            >
                {translateKey('carePath.turnOffRight')}
            </Button>

            {showServiceRightStopModal && (
                <ServiceRightStopModal
                    alertMessage={getAlertMessage()}
                    bodyText={translateKey(
                        'serviceRightStopModal.bodyRight',
                        serviceRightTypeText.toLowerCase(),
                        serviceRight.service.name
                    )}
                    endDate={today.toDate()}
                    onClose={() => setShowServiceRightStopModal(false)}
                    organizationId={organizationId}
                    reloadServiceRights={reloadServiceRights}
                    serviceConsumerRights={serviceConsumerRights}
                    serviceEmploymentRights={serviceEmploymentRights}
                    serviceProviderRights={serviceProviderRights}
                    serviceReaderRights={serviceReaderRights}
                    serviceSupervisorRights={serviceSupervisorRights}
                    stopServiceGroup={false}
                    title={getTitleMessage()}
                />
            )}
        </>
    );

    function getTitleMessage() {
        const key = DateTime.from(serviceRight.startDate).isAfter(today)
            ? 'serviceRightStopModal.titleRemoveRights'
            : 'serviceRightStopModal.titleRight';

        return translateKey(key, serviceRightTypeText, serviceRight.service.name);
    }

    function getAlertMessage() {
        if (serviceRightType === 'ServiceReader') {
            return translateKey(
                'serviceRightStopModal.warningRightServiceReader',
                translateKey(`episodeCategoryEnum.${serviceRight?.service.episodeCategory.name}`)
            );
        }

        return translateKey(
            'serviceRightStopModal.warningRight',
            serviceRightTypeText.toLowerCase(),
            serviceRight?.service.name
        );
    }
}
